import styled from 'styled-components';
import { color, spacing } from 'theme';

export const Root = styled.div`
  background: ${color('indigo_700')};
  padding: ${spacing('xl')};
  color: #fff;
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  border-radius: 10px;
  max-width: 20rem;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
`;

export const Close = styled.button`
  border: 0;
  background: none;
  padding: 0;
  margin: 0;
  position: absolute;
  cursor: pointer;
  top: 1rem;
  right: 1rem;

  svg {
    color: white;
  }
`;

export const Intro = styled.div`
  text-align: center;
  margin: auto;

  p {
    font-size: 1rem;
  }
`;
